import isEmpty from 'lodash/isEmpty';
import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import {
    getInstructionCards,
    setInstructionCards,
    getIsMobileWrapperFlag,
} from '~shared/utils/user';

import {
    ZERO,
    BETFEED_SWIPER_CLASS,
    BETFEED_SWIPER_DISMISS_CLASS,
    DISMISS_URL,
} from '../constants/constants';

/**
 * External function to remove instruction card when dismissed
 * Imported to dismiss button for clicking and also to carousel as swiping is used to dismiss
 * @param {string} type type of instruction card
 * @param {object} swiper swiper element
 * @return {Array} updated instructionCards array
 */
export async function removeInstructionCard(type = '', swiper = {}) {
    let instructionCards = getInstructionCards();

    if (instructionCards.indexOf(type) >= ZERO) {
        const INSTRUCTION_CARD_DISMISS = `${DISMISS_URL}${type}`;
        const url = buildSpectateUrl(INSTRUCTION_CARD_DISMISS);
        const response = await post(url);

        if (response.ok) {
            if(!isEmpty(swiper)) {
                const removeSlideTimeout = 500;
                const instructionSlide = swiper.getElementsByClassName(BETFEED_SWIPER_CLASS)[ZERO];
                instructionSlide.classList.add(BETFEED_SWIPER_DISMISS_CLASS);
                if (!getIsMobileWrapperFlag()) {
                    setTimeout(() => {
                        const parentSlide = instructionSlide.parentNode;
                        if (parentSlide) {
                            parentSlide.removeChild(instructionSlide);
                        }
                    }, removeSlideTimeout);
                }
            }
            instructionCards = instructionCards.filter((value) => { return value !== type;});
            setInstructionCards(instructionCards);

            return instructionCards;
        }
    }

    if (!isEmpty(swiper)) {
        return null;
    }

    return instructionCards;
}

/**
 * Function to show/hide betslip instruction cards
 * @param {array} selectionsIds selection ids
 * @return {null} null
 */
export function betslipCheckForInstructionCard(selectionsIds) {
    const instructionCardPlaceHolder = document.querySelector('#betslip_instruction_card');

    if (selectionsIds.allSelectionsOrdered.length === ZERO) {
        instructionCardPlaceHolder.classList.remove('betslip-instruction-card__hidden');
    } else {
        instructionCardPlaceHolder.classList.add('betslip-instruction-card__hidden');
    }
}
